import React, { useRef, useEffect, useState } from "react";
import "./OtpVerificationModal.css";

export default function OtpVerificationModal({
  otpInput,
  setOtpInput,
  verifyOtp,
  otpError,
  isLoading,
  onResendOtp,
}) {
  const inputsRef = useRef([]);
  const [timer, setTimer] = useState(300);
  const [resendEnabled, setResendEnabled] = useState(false);

  const formData = JSON.parse(sessionStorage.getItem("formData")) || {};
  const user_email = formData.email;

  const otpArray = otpInput.split("").concat(Array(6).fill("")).slice(0, 6);

  const handleChange = (e, index) => {
    const value = e.target.value.replace(/\D/g, "");
    if (value.length <= 1) {
      const newOtp = [...otpArray];
      newOtp[index] = value;
      setOtpInput(newOtp.join(""));
      if (value && index < 5) {
        inputsRef.current[index + 1]?.focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otpArray[index] && index > 0) {
      inputsRef.current[index - 1]?.focus();
    }
  };

  const handleResend = () => {
    if (!resendEnabled) return;
    setTimer(300);
    setResendEnabled(false);
    onResendOtp?.();
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasted = e.clipboardData
      .getData("text")
      .replace(/\D/g, "")
      .slice(0, 6);
    if (pasted.length === 0) return;

    const newOtp = [...otpArray];
    for (let i = 0; i < pasted.length; i++) {
      newOtp[i] = pasted[i];
      inputsRef.current[i]?.focus();
    }
    setOtpInput(newOtp.join(""));
  };

  useEffect(() => {
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  useEffect(() => {
    let interval;
    if (timer > 0) {
      interval = setInterval(() => setTimer((t) => t - 1), 1000);
    } else {
      setResendEnabled(true);
    }
    return () => clearInterval(interval);
  }, [timer]);

  return (
    <div className="otp-modal-overlay">
      <div className="otp-modal">
        <div className="otp-modal-text">
          <h1>Verify your Email</h1>
          <p>
            We have sent a six-digit verification code to{" "}
            <span className="user-email">{user_email}</span>
          </p>
        </div>

        <div className="otp-modal-content">
          <p className="verification-text">Enter Verification code</p>
          <div className="otp-input-group">
            {otpArray.map((digit, index) => (
              <input
                key={index}
                type="text"
                inputMode="numeric"
                maxLength={1}
                value={digit}
                onPaste={index === 0 ? handlePaste : null}
                onChange={(e) => handleChange(e, index)}
                onKeyDown={(e) => handleKeyDown(e, index)}
                ref={(el) => (inputsRef.current[index] = el)}
                className="otp-input"
              />
            ))}
          </div>

          <div className="resend-container">
            {resendEnabled ? (
              <button className="resend-button" onClick={handleResend}>
                Resend Code
              </button>
            ) : (
              <p className="resend-timer">
                Send code again{" "}
                <span>
                  {String(Math.floor(timer / 60)).padStart(2, "0")}:
                  {String(timer % 60).padStart(2, "0")}
                </span>
              </p>
            )}
          </div>

          {otpError && <p className="otp-error">{otpError}</p>}

          {isLoading ? (
            <div className="loader-spinner"></div>
          ) : (
            <div className="otp-button-group">
              <button className="otp-button primary" onClick={verifyOtp}>
                Verify Email
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
